export const SHIPMENT_RESET_STATE = 'SHIPMENT_RESET_STATE';
export const SHIPMENT_CURRENT_ITEM = 'SHIPMENT_CURRENT_ITEM';

export const SHIPMENT_REQUEST_LOADING = 'SHIPMENT_REQUEST_LOADING';
export const SHIPMENT_REQUEST_SUCCESS = 'SHIPMENT_REQUEST_SUCCESS';
export const SHIPMENT_REQUEST_FAILED = 'SHIPMENT_REQUEST_FAILED';

export const SHIPMENT_CURRENT_ACTION = 'SHIPMENT_CURRENT_ACTION';
export const SHIPMENT_RESET_ACTION = 'SHIPMENT_RESET_ACTION';